import MultiEditor from './src/multi-editor.js';

export default { MultiEditor };
